<template>
  <CustomHeaderModal
    :isShowModal="isShowModal"
    @cancel="cancel">
    <!-- ヘッダー -->
    <header class="card-header">
      <div class="cover-filter">
        <p class="card-header-title">
          {{user.name}} - 予定
        </p>
      </div>
    </header>
    <template v-if="isSLoading || this.users.length === 0">
      <div style="width: 100%; height: 500px; position: relative;">
        <OverlayLoading
          :absoluteFlg="true"
          v-if="isSLoading"/>
      </div>
    </template>
    <template v-else-if="getRenkei()">
    <!-- カレンダー -->
    <div class="task-view" id="task" @scroll="scrollRead">
      <OverlayLoading
        :absoluteFlg="false"
        v-if="isDLoading"/>
      <!-- 日毎リスト -->
      <div class="task-day" v-for="i in dateList" :key="i" :id="'day-' + i">
        <div class="task-day-box">
          <h2 class="task-day-title" :class="{'-today': i===0}">
            {{getDateTitle(i)}}
          </h2>
        </div>
        <template v-if="scheduleFilter(i).length > 0">
          <div class="task-event"
            v-for="(date, idx) in scheduleFilter(i)" :key="idx + '-task'"
            :style="getBorder(date)">
            <p class="task-event-by">
              {{getEventBy(date)}}
            </p>
            <p class="task-event-date">
              <span class="mdi mdi-clock-outline -right-4px"></span>
              {{getEventDate(date)}}
            </p>
            <p class="task-event-title">
              <Tooltip :message="date.title">
                <span class="mdi mdi-calendar-text -right-4px"></span>
                {{date.title}}
              </Tooltip>
            </p>
            <!-- line -->
            <div class="line"></div>
            <!-- 参加メンバー -->
            <div class="task-event-member" v-if="date.attendees.length > 0">
              <div class="member-status">
                <span class="mdi mdi-account-location"></span>
                {{date.attendees.length}}
              </div>
              <div class="member">
                <Tooltip :message="getMember(date.attendees)">
                  <template v-for="(member, idxMember) in date.attendees">
                    <p :key="idxMember + 'member'" v-if="idxMember < 2">
                      {{member.email}}
                    </p>
                  </template>
                </Tooltip>
              </div>
            </div>
            <!-- 添付ファイル -->
            <template v-if="isFileAttached(date)">
              <p class="task-event-file">
                <span class="mdi mdi-file-document" style="margin-right: 4px;"></span>
                添付ファイルあり
              </p>
            </template>
            <template v-else>
              <p class="task-event-file">
                <span class="mdi mdi-file-document" style="margin-right: 4px;"></span>
                添付ファイルなし
              </p>
            </template>
          </div>
        </template>
        <template v-else>
          <p class="no-events">予定がありません。</p>
        </template>
      </div>　　　　　
    </div>
    </template>
    <template v-else>
      <div style="padding: 24px;">
        本ユーザーは予定を連携しておりません。
      </div>
    </template>
    <div class="footer-box">
      <button class="button nav-button" @click="cancel()">
        閉じる
      </button>
    </div>
  </CustomHeaderModal>
</template>

<script>
import moment from 'moment'
import Tooltip from '@/components/atoms/tooltips/Tooltip'
import OverlayLoading from '@/components/animations/OverlayLoading'
import CustomHeaderModal  from '@/components/Modals/CustomHeaderModal'
export default {
  components: {
    Tooltip,
    OverlayLoading,
    CustomHeaderModal,
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    eventGroup: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      now: new Date(),
      dateList: [-4, -3, -2, -1, 0, 1, 2, 3, 4],
      schedules: [],
      isSLoading: true,
      isDLoading: false
    }
  },
  computed: {
    scheduleFilter: function () {
      return function (idx) {
        let ret = []
        let now = new Date()
        now.setDate(now.getDate() + idx)
        for (const s of this.schedules) {
          let start = new Date(s.start)
          let end = new Date(s.end)
          if ( start.getFullYear() <= now.getFullYear()
              &&
               start.getMonth() <= now.getMonth()
              &&
               start.getDate() <= now.getDate()
              &&
               end.getFullYear() >= now.getFullYear()
              &&
               end.getMonth() >= now.getMonth()
              &&
               end.getDate() >= now.getDate()
             ) {
               ret.push(s)
             }
        }
        return ret
      }
    }
  },
  created () {
    this.isSLoading = true
    this.$store.dispatch('calendar/getSchedulesOne', {
      year  : this.now.getFullYear(),
      month : this.now.getMonth() + 1,
      day   : this.now.getDate(),
      uuid  : this.user.user_hash
    }).then((data) => {
      this.$set(this, 'schedules', data.schedules)
      this.isSLoading = false
      this.scrollSelect(0)
    })
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    changeSchedules (date) {
      if ( this.now.getFullYear() !== date.getFullYear()
        || this.now.getMonth()    !== date.getMonth()
        || this.now.getDate()     !== date.getDate()
      ) {
        this.now = date
        this.isDLoading = true
        this.$store.dispatch('calendar/getSchedulesOne', {
          year  : this.now.getFullYear(),
          month : this.now.getMonth() + 1,
          day   : this.now.getDate(),
          uuid  : this.user.user_hash
        }).then((sData) => {
          this.schedules = this.$_.union(this.schedules, sData.schedules)
          this.isDLoading = false
        })
      }
    },
    getRenkei () {
      let idx = this.$_.findIndex(
        this.users,
        ((obj) => {
          return obj.user_hash === this.user.user_hash
        })
      )
      // error のばあいはFalseで
      if (idx === -1) {
        return false
      } else if (
        this.users[idx].is_google_calendar_auth ||
        this.users[idx].is_cybozu_office_auth   ||
        this.users[idx].is_garoon_auth          ||
        this.users[idx].is_msoffice_auth
      ) {
        return true
      } else {
        return false
      }
    },
    scrollRead (e) {
      if (this.schedules.length === 0) return
      if (e.target.scrollTop === 0) {
        let now = new Date()
        let target = this.dateList[0]
        now.setDate(now.getDate() + target)
        this.changeSchedules(now)
        for (let i = 0; i < 7; i++) {
          this.dateList.unshift(target - i - 1)
        }
        this.scrollSelect(target)
      } else if (e.target.scrollTop >= e.target.scrollHeight - 700) {
        let now = new Date()
        let target = this.dateList[this.dateList.length - 1]
        now.setDate(now.getDate() + target)
        this.changeSchedules(now)
        for (let i = 0; i < 7; i++) {
          this.dateList.push(target + i + 1)
        }
        this.scrollSelect(target)
      }
    },
    scrollSelect (i) {
      setTimeout(() => {
        let scrollHeight = document.getElementById("day-" + i)
        if (scrollHeight) {
          document.getElementById("task").scrollTop = scrollHeight.offsetTop - 120
        }
      }, 100)
    },
    getDateTitle (i) {
      let now = new Date()
      now.setDate(now.getDate() + i)
      return now.getFullYear() + '年 ' + (now.getMonth() + 1) + '月 ' + now.getDate() + '日'
    },
    getBorder (event) {
      return {
        'border': 'solid 1.5px ' + event.backgroundColor
      }
    },
    getEventBy (event) {
      let name = 'メンバー'
      for (const user of this.users) {
        if (user.user_hash === event.className.replace('class-', '')) {
          name = user.username
        }
      }
      return name + 'の予定'
    },
    getEventDate (event) {
      let start = new Date(event.start)
      let end = new Date(event.end)
      return ('00' + start.getHours()).slice(-2) + ':' + ('00' + start.getMinutes()).slice(-2) + ' - ' +
        ('00' + end.getHours()).slice(-2) + ':' + ('00' + end.getMinutes()).slice(-2)
    },
    isFileAttached (event) {
      let flg = false
      for (const e of this.eventGroup) {
        if (e.calendar_id === event.id) flg = true
      }
      return flg
    },
    getMember (member) {
      let text = ''
      for (const m of member) {
        text += m.email + '\n'
      }
      return text
    },
  },
}
</script>

<style lang="scss" scoped>
.cover-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .card-header-title {
    font-size: 24px;
    font-weight: 600;
  }
  .nav-button {
    color: #a22;
    border: solid 2px #a22;
    font-weight: 800;
  }
  div {
    display: flex;
    button {
      margin: 8px;
    }
  }
}
.task-view {
  padding: 24px;
  height: 500px;
  width: 100%;
  text-align: left;
  overflow: scroll;
  position: relative;
  .task-day {
    margin-top: 16px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .task-day-box {
      width: 100%;
      margin-bottom: 16px;
      .task-day-title {
        padding: 8px 16px;
        font-size: 20px;
        font-weight: 600;
        color:#fff;
        background:#AA0066;
      }
      .-today {
        border: double 4px #FFF;
      }
    }
    .task-event {
      width: 280px;
      height: 191px;
      padding: 16px;
      margin: 8px;
      border: solid thin #ccc;
      border-radius: 8px;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
      /deep/ .tooltip {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .task-event-by {
        color: #666;
        font-size: 12px;
      }
      .task-event-date {
        font-weight: 600;
      }
      .task-event-title {
        font-weight: 600;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .line {
        width: 100%;
        height: 0.5px;
        border-bottom: dotted 4px #ccc;
        margin: 1px;
      }
      .task-event-member {
        display: flex;
        align-items: center;
        width: 100%;
        .member-status {
          width: 40px;
        }
        .member {
          width: calc(100% - 40px);
          p {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  .no-events {
    padding: 12px;
    text-align: left;
  }
}
.task-view::-webkit-scrollbar {
  width:  8px;
  height: 8px;
  visibility: hidden;
}
.footer-box {
  border-top: solid thin #ccc;
  width: 100%;
  padding: 8px;
  padding-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button {
    width: 100%;
    border: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/VirtualOffice/organisms/ModalDetailSchedule.vue